import { styled } from "@mui/material";
import { FiLink2 } from "react-icons/fi";

export const LinkIcon = styled(FiLink2)(() => ({
  color: "#38CFC4",
  marginLeft: "10px",
  cursor: "pointer",
}));

export const LinkContainer = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));
